import { render, staticRenderFns } from "./ft.vue?vue&type=template&id=61747c9f&scoped=true&"
import script from "./ft.vue?vue&type=script&lang=js&"
export * from "./ft.vue?vue&type=script&lang=js&"
import style0 from "./ft.vue?vue&type=style&index=0&id=61747c9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61747c9f",
  null
  
)

export default component.exports